import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Button, Container, Icon, IconButton } from "@/components/atoms";
import { Tabs } from "@/components/molecules";
import { PageHeader } from "@/components/organisms";
import { InviteNetworkCodeModal } from "@/components/organisms/PrivateNetwork/modals/InviteNetworkCodeModal";
import { InviteNetworkEmailModal } from "@/components/organisms/PrivateNetwork/modals/InviteNetworkEmailModal";
import { PrivateNetworkHelpModal } from "@/components/organisms/PrivateNetwork/modals/PrivateNetworkHelpModal";
import { PrivateNetworkStep } from "@/components/organisms/PrivateNetwork/types";
import { PrivateNetworkActive } from "./PrivateNetworkActive";
import { PrivateNetworkArchived } from "./PrivateNetworkArchived";
import { PrivateNetworkFleetLeaders } from "./PrivateNetworkFleetLeaders";
import { PrivateNetworkHistory } from "./PrivateNetworkHistory";

export const PrivateNetwork = () => {
  const [step, setStep] = useState<PrivateNetworkStep>(undefined);

  // The info icon explains the Private Network, so it lives on that tab. preventDefault/stopPropagation
  // keeps the click on the icon from triggering the tab's NavLink navigation.
  const pageTabs = [
    {
      name: "Private Network",
      to: "private-network",
      icon: (
        <Icon
          name="InfoCircle"
          variant="Bold"
          size="md"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setStep("help");
          }}
          className="ml-1.5 rotate-180 cursor-pointer text-neutral-dark-gray"
        />
      ),
    },
    { name: "Archived Network", to: "archive-network" },
  ];

  return (
    <Container className="mb-12 flex w-full flex-1 flex-col">
      <div className="sticky top-0 z-30 w-full bg-white">
        <PageHeader title="RM Network" skipCrumbs={1} />
        <div className="flex w-full items-center gap-2 border-b !border-neutral-mid-gray py-1 max-xl:justify-between lg:py-0">
          <Tabs className="no-scrollbar min-w-0 border-none" tabs={pageTabs} />
          <div className="ml-auto flex flex-row items-center">
            <div className="hidden sm:flex sm:flex-row sm:gap-x-1">
              <Button variant="primary" size="sm" startIcon="Add" onClick={() => setStep("inviteCode")}>
                Invite Operator
              </Button>
            </div>
            <div className="flex flex-row gap-x-1 sm:hidden">
              <IconButton variant="primary" size="sm" iconName="Add" onClick={() => setStep("inviteCode")} />
            </div>
          </div>
        </div>
      </div>
      <Outlet />
      <InviteNetworkCodeModal open={step === "inviteCode"} onClose={() => setStep(undefined)} setStep={setStep} />
      <InviteNetworkEmailModal open={step === "inviteEmail"} onClose={() => setStep(undefined)} />
      <PrivateNetworkHelpModal open={step === "help"} onClose={() => setStep(undefined)} />
    </Container>
  );
};

PrivateNetwork.Active = PrivateNetworkActive;
PrivateNetwork.Archived = PrivateNetworkArchived;
PrivateNetwork.History = PrivateNetworkHistory;
PrivateNetwork.FleetLeaders = PrivateNetworkFleetLeaders;
